<template>
  <v-dialog v-model="internalValue"
            max-width="500"
            persistent
            content-class="celebration-dialog">
    <v-card class="text-center pa-6 celebration-card">
      <div class="celebration-icon-wrapper mb-4">
        <v-icon size="80" color="success">mdi-party-popper</v-icon>
      </div>
      <h2 class="celebration-title mt-2 mb-3">Parabens!</h2>
      <p class="grey--text text--darken-1 celebration-message mb-4">
        Voce completou a configuracao inicial da plataforma!<br>
        Agora voce esta pronto para usar todos os recursos da Regularizei.
      </p>
      <p class="grey--text text--darken-1 text-body-2 mb-6">
        Caso tenha duvidas, consulte nossa documentacao completa.
      </p>
      <div class="d-flex flex-column align-center gap-3">
        <v-btn color="primary"
               large
               depressed
               class="celebration-btn"
               @click="close">
          <v-icon left>mdi-rocket-launch</v-icon>
          Comecar a usar
        </v-btn>
        <v-btn color="info"
               outlined
               class="celebration-btn"
               href="https://chat.regularizei.app.br/hc/r/pt_BR"
               target="_blank"
               @click="close">
          <v-icon left>mdi-book-open-variant</v-icon>
          Ver documentacao
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import confetti from 'canvas-confetti'

export default defineComponent({
  name: 'OnboardingCelebration',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const internalValue = ref(props.value)

    // Sincronizar com prop
    watch(() => props.value, (newVal) => {
      internalValue.value = newVal
      if (newVal) {
        triggerCelebration()
      }
    }, { immediate: true })

    // Emitir mudancas
    watch(internalValue, (newVal) => {
      emit('input', newVal)
    })

    const triggerCelebration = () => {
      // Primeira explosao
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 }
      })

      // Segunda explosao com delay
      setTimeout(() => {
        confetti({
          particleCount: 50,
          angle: 60,
          spread: 55,
          origin: { x: 0 }
        })
      }, 250)

      // Terceira explosao do outro lado
      setTimeout(() => {
        confetti({
          particleCount: 50,
          angle: 120,
          spread: 55,
          origin: { x: 1 }
        })
      }, 400)
    }

    const close = () => {
      internalValue.value = false
      // Salvar no localStorage que ja viu a celebracao
      localStorage.setItem('onboarding_celebration_seen', 'true')
    }

    return {
      internalValue,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.celebration-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.celebration-icon-wrapper {
  animation: bounce 1s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.celebration-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
}

.celebration-message {
  font-size: 16px;
  line-height: 1.6;
}

.celebration-btn {
  min-width: 200px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;

  & + & {
    margin-top: 12px;
  }
}
</style>

<style lang="scss">
// Estilo global para garantir que o dialog de celebracao apareca acima de tudo
.celebration-dialog {
  z-index: 10002 !important;
}

// Overlay do dialog de celebracao tambem precisa de z-index alto
.v-dialog__content:has(.celebration-dialog) {
  z-index: 10001 !important;
}
</style>
